import { render, staticRenderFns } from "./templateShopee.vue?vue&type=template&id=b1e4c8a4&scoped=true"
import script from "./templateShopee.vue?vue&type=script&lang=js"
export * from "./templateShopee.vue?vue&type=script&lang=js"
import style0 from "./templateShopee.vue?vue&type=style&index=0&id=b1e4c8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e4c8a4",
  null
  
)

export default component.exports